import { render } from "./Event.vue?vue&type=template&id=a061e3b6&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=a061e3b6&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a061e3b6"]])

export default __exports__